import { action } from 'typesafe-actions';
import { AgrupamentosTypes, Agrupamentos } from './types';

export const loadRequest = (inscricoesEstaduais: number[]) =>
  action(AgrupamentosTypes.LOAD_REQUEST, { inscricoesEstaduais });

export const loadSuccess = (data: Agrupamentos[]) =>
  action(AgrupamentosTypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(AgrupamentosTypes.LOAD_FAILURE);
